<!-- digi-alert-popup.component.html -->
    <div class="alert-popup-container" (click)="$event.stopPropagation()">
      
      <!-- Header -->
      <div class="popup-header">
        <h2 class="popup-title">ALERTS</h2>
        <button type="button" class="close-btn" mat-dialog-close>
        <span>&times;</span>
        </button>
      </div>
      
      <!-- Filter Section -->
      <div style="width: 100%;background-color: rgb(52, 100, 142);padding-bottom: 3px;color:white" class="row">
        <div class="col-md-1"></div>
        <div class="col-md-4" style="padding: 4px;">
          <mat-label class="device-label">Select Device</mat-label>
          <mat-select class="device-select" [(ngModel)]="selectedDevice" (selectionChange)="onDeviceSelect($event.value)">
            <mat-option  *ngFor="let dev of generatorIds" [value]="dev">
              {{ dev.digiid }} ({{ dev.sitename }})
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-4">
          <mat-label>Duration </mat-label>  
          <mat-select    [(value)]="timeFilter">
              <mat-option  *ngFor="let time of timeOptions" [value]="time"  (click)='filters(time)'>
                  {{time}}
                </mat-option>
            </mat-select>
        </div>
        <div class="col-md-2">
          <p style="margin-left: 2%;"><b>Download In:</b></p>
                    <div>
                      <button style="margin-left: 2%;"  mat-button (click)="exporter.exportTable('xlsx',{fileName:'Report'})"><img src="../../assets/images/icons8-microsoft-excel-30.png">
                      </button>
                    </div>
        </div>
    </div>
      
      <!-- Alert Table -->
      <div class="table-container">
        <mat-card class="report-table-card">
          <div class="mat-elevation-z8">
            <table mat-table matTableExporter [dataSource]="dataSource" #exporter="matTableExporter" matSort class="mat-table full-width">
        
              <!-- Dynamic Column Definitions -->
              <ng-container *ngFor="let col of reportColumns" [matColumnDef]="col">
                <th mat-header-cell *matHeaderCellDef> {{ col | titlecase }} </th>
                <td mat-cell *matCellDef="let row"> {{ row[col] }} </td>
              </ng-container>
        
              <!-- Header & Row Declarations -->
              <tr mat-header-row *matHeaderRowDef="reportColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: reportColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
          </div>
        </mat-card>
        <!-- Empty State -->
        <div class="empty-state" *ngIf="!isData">
          <div class="empty-icon">⚠️</div>
          <div class="empty-message">No alerts found matching the selected filters.</div>
        </div>
      </div>
      
    
      
    </div>
